import axios from "../../../utils/axios";
import { getContentType } from "../../../utils/common-utils";

export const uploadFile = async (file) => {
  return await axios.get(`/files/upload-request/${file.name}/`);
};

export const uploadFileOnURL = async (file, uploadUrl) => {
  const { type } = file;
  const contentType = getContentType(type.split("/")[1]);

  return await axios.updateFile(
    uploadUrl,
    file,
    { "Content-Type": contentType },
    true
  );
};

export const uploadMultipleFiles = async (files) => {
  const uploadRequests = files.map(({ name }) =>
    axios.get(`/files/upload-request/${name}/`)
  );

  return await Promise.all(uploadRequests);
};

export const uploadFilesOnURLs = async (fileURLs, files) => {
  const urlRequests = fileURLs.map(({ data: { uploadUrl } }, index) => {
    const file = files[index];

    const contentType = getContentType(file.type.split("/")[1]);

    return { uploadUrl, file, contentType };
  });

  return await Promise.all(
    urlRequests.map(({ uploadUrl, file, contentType }) =>
      axios.updateFile(uploadUrl, file, { "Content-Type": contentType }, true)
    )
  );
};
